export const blockIconsNotificationSms = (
	<span className='material-symbols-outlined'>sms</span>
);
